import {addBaseQueryParams, addQueryParams} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";
import axios from "axios";
import {CalendarioChiusureRecord} from "@commons/mapping/CalendarioChiusureRecord";
import {TabellaGiustAutoRecord} from "@commons/mapping/TabellaGiustAutoRecord";
import {GiustAutoXTabellaRecord} from "@commons/mapping/GiustAutoXTabellaRecord";
import {QualificaEccRecord} from "@commons/mapping/QualificaEccRecord";
import {QuantificaEccRecord} from "@commons/mapping/QuantificaEccRecord";
import {FlexRecord} from "@commons/mapping/FlexRecord";
import {TolleranzaRecord} from "@commons/mapping/TolleranzaRecord";
import {TabellaAlternativiTurniRecord} from "@commons/mapping/TabellaAlternativiTurniRecord";
import {AziendaParams} from "@commons/services/presenze_api/tabelleAzienda.api";

interface TabellaSpecificaAziendaParams extends AziendaParams {
    idTabella: number
}

interface AziendaCalendarioParams extends AziendaParams {
    idTabella: number,
    anno: number,
}

interface RegolaGiustAutoParams extends TabellaSpecificaAziendaParams {
    idRegola: number
}

export const listTabelleQualificazioneEccedenze = (params: AziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/eccedenze/qualificazione?${addQueryParams(queryParams)}`
    return axios<QualificaEccRecord[]>(url).then(res => res.data)
}
export const getTabellaQualificazioneEccedenze = (params: TabellaSpecificaAziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/eccedenze/qualificazione/${params.idTabella}?${addQueryParams(queryParams)}`
    return axios<QualificaEccRecord>(url).then(res => res.data)
}
export const listTabelleQuantificazioneEccedenze = (params: AziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/eccedenze/quantificazione?${addQueryParams(queryParams)}`
    return axios<QuantificaEccRecord[]>(url).then(res => res.data)
}
export const getTabellaQuantificazioneEccedenze = (params: TabellaSpecificaAziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/eccedenze/quantificazione/${params.idTabella}?${addQueryParams(queryParams)}`
    return axios<QuantificaEccRecord>(url).then(res => res.data)
}

export const listCalendariChiusure = (params: AziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/calendario?${addQueryParams(queryParams)}`
    return axios<CalendarioChiusureRecord[]>(url).then(res => res.data)
}
export const getCalendarioChiusure = (params: AziendaCalendarioParams) => {
    const queryParams: string[] = [];
    queryParams.push(`anno=${params.anno}`);
    addBaseQueryParams(params, queryParams);

    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/calendario/${params.idTabella}?${addQueryParams(queryParams)}`
    return axios<CalendarioChiusureRecord>(url).then(res => res.data)
}

export const listTabelleGiustAuto = (params: AziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/tabellaGiustAuto?${addQueryParams(queryParams)}`
    return axios<TabellaGiustAutoRecord[]>(url).then(res => res.data)
}
export const getTabellaGiustAuto = (params: TabellaSpecificaAziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/tabellaGiustAuto/${params.idTabella}?${addQueryParams(queryParams)}`
    return axios<TabellaGiustAutoRecord>(url).then(res => res.data)
}

export const listRegoleTabellaGiustAuto = (params: TabellaSpecificaAziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/tabellaGiustAuto/${params.idTabella}/regola?${addQueryParams(queryParams)}`
    return axios<GiustAutoXTabellaRecord[]>(url).then(res => res.data)
}

export const getRegolaTabellaGiustAuto = (params: RegolaGiustAutoParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/tabellaGiustAuto/${params.idTabella}/regola/${params.idRegola}?${addQueryParams(queryParams)}`
    return axios<GiustAutoXTabellaRecord>(url).then(res => res.data)
}

export const listTabelleFlex = (params: AziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/flex?${addQueryParams(queryParams)}`
    return axios<FlexRecord[]>(url).then(res => res.data)
}
export const getTabellaFlex = (params: TabellaSpecificaAziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/flex/${params.idTabella}?${addQueryParams(queryParams)}`
    return axios<FlexRecord>(url).then(res => res.data)
}

export const listTabelleTolleranza = (params: AziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/flex?${addQueryParams(queryParams)}`
    return axios<TolleranzaRecord[]>(url).then(res => res.data)
}
export const getTabellaTolleranza = (params: TabellaSpecificaAziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/tolleranza/${params.idTabella}?${addQueryParams(queryParams)}`
    return axios<TolleranzaRecord>(url).then(res => res.data)
}

export const listTurniXTabellaAlternativi = (params: TabellaSpecificaAziendaParams) => {
    const queryParams: string[] = addBaseQueryParams(params);
    const url = config.getBaseUrl('FPNet') + `/presenze/${params.idAziendaTabelle}/alternativo/${params.idTabella}/turno?${addQueryParams(queryParams)}`
    return axios<TabellaAlternativiTurniRecord[]>(url).then(res => res.data)
}

export const getCalendarioChiusureByAnno = ({idAzienda, anno, auth_token}: { idAzienda: number, anno: number, auth_token?: string }) => {
    const url = config.getBaseUrl('FPNet') + `/presenze/${idAzienda}/calendario/anno/${anno}${auth_token ? '?auth_token=' + auth_token : ''}`
    return axios<CalendarioChiusureRecord>(url).then(res => res.data, err => CalendarioChiusureRecord.factory())
}
